import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import LoadingSpinner from '../common/LoadingSpinner';
import AccessDenied from './AccessDenied';
import { APP_ROUTES } from '../../constants';
import { hasPermission } from '../../utils/rbac';

const ProtectedRoute = ({ children, permission }) => {
  const {
    isAuthenticated,
    loading,
    user,
    ensureActiveSession,
    hydrateProfile,
    isSessionExpired
  } = useAuthStore();
  const location = useLocation();
  const sessionExpired = isAuthenticated && isSessionExpired();

  useEffect(() => {
    if (!ensureActiveSession()) return;
    if (isAuthenticated && !user?.adminRole) {
      hydrateProfile();
    }
  }, [ensureActiveSession, hydrateProfile, isAuthenticated, user?.adminRole]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (sessionExpired) {
    return (
      <Navigate
        to={APP_ROUTES.LOGIN}
        state={{ reason: 'idle_timeout', from: location }}
        replace
      />
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={APP_ROUTES.LOGIN}
        state={{ from: location }}
        replace
      />
    );
  }

  if (user?.role !== 'admin') {
    return <AccessDenied requiredPermission="admin" />;
  }

  if (permission && !hasPermission(user, permission)) {
    return <AccessDenied requiredPermission={permission} />;
  }

  return children;
};

export default ProtectedRoute;
